import Grid from "@mui/material/Grid";
import CustomBtnFilled from "../../atoms/form-molecules/CustomBtnFilled";
import { useHookFormContext } from "../../utils/hooks/useHookFormContext";
import { NotificationEvents } from "../../constants";
import { HookCheckBox } from "../../atoms/form-fields/SLFieldCheckBox";
import { Notifications } from "./helper";
import { inputRowCommonStyles, submitbtnRowCommonStyles } from "../../common/formStyles";


const NotificationSelectionFields = (props: any) => {
  const { registerState } = useHookFormContext();

  return (
    <>
      <Grid container>
        <Grid sx={inputRowCommonStyles} item xs={6} sm={4}>
            <HookCheckBox
                {...registerState(Notifications.COMPLIANCE_COMPLETED)}
                label={NotificationEvents[Notifications.COMPLIANCE_COMPLETED]}
            />
        </Grid>

        <Grid sx={inputRowCommonStyles} item xs={6} sm={4}>
            <HookCheckBox
                {...registerState(Notifications.HONORARIUM_CHANGED)}
                label={NotificationEvents[Notifications.HONORARIUM_CHANGED]}
            />
        </Grid>

        <Grid sx={inputRowCommonStyles} item xs={6} sm={4}>
            <HookCheckBox
                {...registerState(Notifications.High_Priority_Payment)}
                label={NotificationEvents[Notifications.High_Priority_Payment]}
            />
        </Grid>

        <Grid sx={inputRowCommonStyles} item xs={6} sm={4}>
            <HookCheckBox
                {...registerState(Notifications.PAYMENT_COMPLETED)}
                label={NotificationEvents[Notifications.PAYMENT_COMPLETED]}
            />
        </Grid>

        <Grid sx={inputRowCommonStyles} item xs={6} sm={4}>
            <HookCheckBox
                {...registerState(Notifications.PAYMENT_FAILED)}
                label={NotificationEvents[Notifications.PAYMENT_FAILED]}
            />
        </Grid>

        <Grid sx={inputRowCommonStyles} item xs={6} sm={4}>
            <HookCheckBox
                {...registerState(Notifications.PROJECT_INVITE_ACCEPTED)}
                label={NotificationEvents[Notifications.PROJECT_INVITE_ACCEPTED]}
            />
        </Grid>

        <Grid sx={inputRowCommonStyles} item xs={6} sm={4}>
            <HookCheckBox
                {...registerState(Notifications.PROJECT_INVITE_DECLINED)}
                label={NotificationEvents[Notifications.PROJECT_INVITE_DECLINED]}
            />
        </Grid>

        <Grid sx={inputRowCommonStyles} item xs={6} sm={4}>
            <HookCheckBox
                {...registerState(Notifications.Payment_On_Hold)}
                label={NotificationEvents[Notifications.Payment_On_Hold]}
            />
        </Grid>

        <Grid sx={inputRowCommonStyles} item xs={6} sm={4}>
            <HookCheckBox
                {...registerState(Notifications.Payment_Rejected)}
                label={NotificationEvents[Notifications.Payment_Rejected]}
            />
        </Grid>

        <Grid sx={inputRowCommonStyles} item xs={6} sm={4}>
            <HookCheckBox
                {...registerState(Notifications.Payment_Requested)}
                label={NotificationEvents[Notifications.Payment_Requested]}
            />
        </Grid>

        <Grid sx={inputRowCommonStyles} item xs={6} sm={4}>
            <HookCheckBox
                {...registerState(Notifications.TIME_SLOT_SHARED)}
                label={NotificationEvents[Notifications.TIME_SLOT_SHARED]}
            />
        </Grid>


        <Grid sx={submitbtnRowCommonStyles} item xs={12}>
          <CustomBtnFilled
            label="cancel"
            variant="outlined"
            onClick={props.handleClose}
          />
          <CustomBtnFilled
            disabled={props.submitting}
            label={props.submitting ? "loading..." : "submit"}
            variant="contained"
            buttonType="submit"
          />
        </Grid>
      </Grid>
    </>
  );
};

export default NotificationSelectionFields;